import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export interface ArtworkCampus {
  campusId: number;
  abbr: string;
  name: string;
}

export interface ArtworkCampusResponse {
  total: number;
  records: ArtworkCampus[];
}

export const getArtworkCampus = async () => {
  const resp = await axiosInstance.get<BaseResponse<ArtworkCampusResponse>>(
    `${baseUrl}/review/campus/list?currentPage=1&pageSize=100`
  );
  return resp.data;
};

export enum ArtworkVerifyStatus {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 3,
}

export interface ArtworkVerifyListParams {
  campusCertificationId: string; // 认证ID
  suppId: string; // SUPP ID
  fullName: string; // 用户姓名
  email: string; // 用户邮箱
  campusId: number; // 学校ID
  certificationSubmitDate: string; // 认证提交日期
  reviewUser: string; // 操作人员
  reviewKey?: ArtworkVerifyStatus; // 认证状态
  currentPage: number; // 当前页
  pageSize: number; // 每页条数
}

export interface ArtworkVerifyItem {
  campusCertificationId: string;
  userId: string;
  suppId: number;
  fullName: string;
  campusId: number;
  campusName: string;
  campusRemark: string;
  idCardImageUrl: string;
  reviewKey: ArtworkVerifyStatus;
  reviewStatus: string;
  reviewUser: string;
  reviewTime: string;
  createTime: string;
}

export interface ArtworkVerifyListResponse {
  total: number;
  records: ArtworkVerifyItem[];
}

export const getArtworkVerifyList = async (params: ArtworkVerifyListParams) => {
  const resp = await axiosInstance.post<
    BaseResponse<ArtworkVerifyListResponse>
  >(`${baseUrl}/review/campus/certification/list`, params);
  return resp.data;
};

export const getArtworkVerifyDetail = async (campusCertificationId: string) => {
  const resp = await axiosInstance.get<BaseResponse<ArtworkVerifyItem>>(
    `${baseUrl}/review/campus/certification/detail?campusCertificationId=${campusCertificationId}`
  );
  return resp.data;
};

export const artworkCertifactionApprove = async (
  campusCertificationIds: string[]
) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/campus/certification/approve`,
    campusCertificationIds
  );
  return resp.data;
};

export interface artworkCertifactionApproveParams {
  campusCertificationIds: string[];
  dictKeys: string;
  reviewRemark: string;
}

export const artworkCertificationReject = async (
  params: artworkCertifactionApproveParams
) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/review/campus/certification/reject`,
    params
  );
  return resp.data;
};

export interface ArtworkCampusRejectReason {
  businessKey: string;
  parentId: number;
  dictKey: number;
  dictDesc: string;
}

export const getArtworkCampusRejectItems = async () => {
  const resp = await axiosInstance.get<
    BaseResponse<ArtworkCampusRejectReason[]>
  >(`${baseUrl}/dict/campus/reject/item`);
  return resp.data;
};
